
<template>
    <div>
        <div class="row" v-if="isLoadingBlade">
            <div class="col-lg-4"></div>
            <div class="col-lg-4 text-center">
                <base-input alternative=""
                    label="Enter Folio Number/ Email Address / Doctor's Name"
                    placeholder="Enter Folio Number/ Email Address / Doctor's Name"
                    input-classes="form-control-alternative"
                    v-model="key"
                    @keyup.enter="getTheDoctors()"
                    required
                />
            </div>
        </div>

        <div class="col-sm-12 text-center" v-if="showErrorStatus">
            <base-alert :type="errorType">
                <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-inner--text">
                    {{errorMsg}}
                </span>
            </base-alert>
        </div>

        <div class="row" v-if="isLoadingBlade">
            <div class="col-lg-4"></div>
            <div class="col-lg-4 text-center">
                <base-button
                    type="info" size="lg"
                    @click="getTheDoctors()"
                    :disabled="(privileges && privileges.view == 'no') || ! privileges"
                >
                    <i class="fa fa-search"></i>
                    {{isLoading ? 'Please Wait...' : 'Find Doctor'}}
                </base-button>
            </div>
        </div>
    </div>
</template>
<script>

  export default {
    name: 'SearchPage',
    props: ['searchKey', 'privileges', 'showErrorStatus', 'errorType', 'errorMsg', 'findDoctors', 'isLoadingBlade', 'isLoading'],
    data() {
        return {
            key: null
        }
    },
    methods: {
        getTheDoctors() {
            return this.findDoctors(this.key);
        }
    },
    mounted() {
        this.key = this.searchKey;
    }
  };
</script>
<style></style>
